import React, { useEffect, useState } from 'react'
import {
  Button,
  Header,
  Modal,
  Form,
  Input,
  Segment,
  Table,
  Loader,
} from 'semantic-ui-react'
import { ArrowRight } from 'phosphor-react'
import useAxios from '../../../lib/auth/useAxios'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'

function AdminOrderTakeoffs({ order }) {
  const axios = useAxios()
  const navigate = useNavigate()
  const tenant = useSelector((state) => state?.globals?.tenant)
  const [takeoffs, setTakeoffs] = useState([])
  const [loading, setLoading] = useState(false)
  const [createModalOpen, setCreateModalOpen] = useState(false)
  const [newTakeoffName, setNewTakeoffName] = useState('')
  const [newTakeoffDescription, setNewTakeoffDescription] = useState('')
  const [createLoading, setCreateLoading] = useState(false)

  useEffect(() => {
    if (order?.id) {
      loadTakeoffs()
    }
  }, [order?.id])


  const loadTakeoffs = async () => {
    setLoading(true)
    const startTime = performance.now()
    try {
      console.log('🔄 Loading takeoffs for order:', order.id, 'at', new Date().toISOString())

      const response = await axios.get('/main/takeoffs/', {
        params: {
          order_id: order.id,
          page_size: 20  // Reduced from 50 to 20 for better performance
        },
      })

      const endTime = performance.now()
      const duration = endTime - startTime

      console.log('✅ Takeoffs API response received in', Math.round(duration), 'ms')
      console.log('📊 Response data:', response.data)
      console.log('📋 Found takeoffs:', response.data.results?.length || 0)

      setTakeoffs(response.data.results || [])
    } catch (error) {
      const endTime = performance.now()
      const duration = endTime - startTime
      console.error('❌ Error loading takeoffs after', Math.round(duration), 'ms:', error)
      toast.error('Failed to load takeoffs')
    } finally {
      setLoading(false)
    }
  }

  const createTakeoff = async () => {
    if (!newTakeoffName.trim()) {
      toast.error('Please enter a takeoff name')
      return
    }

    setCreateLoading(true)
    try {
      const response = await axios.post('/main/takeoffs/', {
        name: newTakeoffName.trim(),
        description: newTakeoffDescription.trim(),
        order: order.id,
      })

      toast.success('Takeoff created successfully')
      setCreateModalOpen(false)
      setNewTakeoffName('')
      setNewTakeoffDescription('')
      loadTakeoffs()
    } catch (error) {
      console.error('Error creating takeoff:', error)
      toast.error('Failed to create takeoff')
    } finally {
      setCreateLoading(false)
    }
  }

  const createAndStayTakeoff = () => {
    setCreateModalOpen(true)
  }

  const viewTakeoff = (takeoff) => {
    navigate(`/portal/admin/takeoffs/${takeoff.id}`)
  }


  const renderTakeoffRow = (takeoff, index) => {
    if (!takeoff) return null

    return (
      <Table.Row key={takeoff.id || index}>
        <Table.Cell>{takeoff.name}</Table.Cell>
        <Table.Cell>{takeoff.description || '-'}</Table.Cell>
        <Table.Cell>
          {`${takeoff.created_by?.first_name || ''} ${takeoff.created_by?.last_name || ''
            }`.trim() || '-'}
        </Table.Cell>
        <Table.Cell>
          {new Date(takeoff.created_at).toLocaleDateString()}
        </Table.Cell>
        <Table.Cell>
          <Button
            size="small"
            icon={<ArrowRight size={14} />}
            content="View Details"
            onClick={() => viewTakeoff(takeoff)}
          />
        </Table.Cell>
      </Table.Row>
    )
  }

  if (loading) {
    return (
      <div style={{
        position: 'relative',
        minHeight: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Loader active size="large" content="Loading takeoffs..." />
      </div>
    )
  }

  return (
    <div style={{ padding: '10px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginBottom: '0px',
        }}
      >
        <Button
          content="Create Takeoff"
          onClick={createAndStayTakeoff}
          style={{
            backgroundColor: tenant?.deployment_primary_color || '#00b5ad',
            color: 'white'
          }}
        />
      </div>

      <MickeyTable
        headerRow={[
          'Name',
          'Description',
          'Created By',
          'Created At',
          'Actions',
        ]}
        basicSegment
        containerClassName={'takeoffs-table'}
        loadedStyle={{ width: '100%' }}
        data={takeoffs}
        loading={false}
        emptyMessage="No takeoffs found"
        showPagination={takeoffs.length > 10}
        pageSize={10}
        renderBodyRow={renderTakeoffRow}
      />

      <Modal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        size="small"
      >
        <Modal.Header>Create New Takeoff</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field required>
              <label>Name</label>
              <Input
                placeholder="Enter takeoff name"
                value={newTakeoffName}
                onChange={(e) => setNewTakeoffName(e.target.value)}
              />
            </Form.Field>
            <Form.Field>
              <label>Description</label>
              <Input
                placeholder="Enter takeoff description (optional)"
                value={newTakeoffDescription}
                onChange={(e) => setNewTakeoffDescription(e.target.value)}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setCreateModalOpen(false)}>Cancel</Button>
          <Button 
            loading={createLoading} 
            onClick={createTakeoff}
            style={{
              backgroundColor: tenant?.deployment_primary_color || '#00b5ad',
              color: 'white'
            }}
          >
            Create Takeoff
          </Button>
        </Modal.Actions>
      </Modal>

    </div >
  )
}

export default AdminOrderTakeoffs
